<template>
  <div ref="recaptchaContainer"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  siteKey: {
    type: String,
    required: true
  },
  action: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['verify', 'error']);

const recaptchaContainer = ref(null);
let recaptchaId = null;

const executeRecaptcha = async () => {
  if (props.disabled) return;
  
  try {
    const token = await window.grecaptcha.execute(props.siteKey, { action: props.action });
    emit('verify', token);
    return token;
  } catch (error) {
    emit('error', error);
    throw error;
  }
};

onMounted(() => {
  // Cargar el script de reCAPTCHA si no está cargado
  if (!window.grecaptcha) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${props.siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  // Esperar a que reCAPTCHA esté listo
  const checkRecaptcha = setInterval(() => {
    if (window.grecaptcha && window.grecaptcha.ready) {
      clearInterval(checkRecaptcha);
      window.grecaptcha.ready(() => {
        // No ejecutamos reCAPTCHA automáticamente
        // Se ejecutará cuando se llame a executeRecaptcha
      });
    }
  }, 100);
});

onUnmounted(() => {
  if (recaptchaId) {
    window.grecaptcha.reset(recaptchaId);
  }
});

defineExpose({
  executeRecaptcha
});
</script> 